export const name = 'SupportRequestController';

export default function SupportRequestController(
  $state,
  $stateParams,
  Upload,
  $window,
  rnHttp,
  $analytics,
  $q,
  rnLocale,
  $location,
  $gzAnalytics,
  $gzHpId,
  rnRegistry
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const US_VALIDATORS = {
    region: {
      maxlength: 2,
      validator: 'Validator.AAA.USState'
    },
    postalCode: {
      maxlength: 10,
      validator: 'Validator.AAA.USPostalCode'
    }
  };

  const CANADA_VALIDATORS = {
    region: {
      maxlength: 2,
      validator: 'Validator.AAA.CAProvidences'
    },
    postalCode: {
      maxlength: 7,
      validator: 'Validator.AAA.CAPostalCode'
    }
  };

  const DEFAULT_VALIDATORS = {
    region: {
      maxlength: 100,
      validator: 'Validator.AAA.DescriptionUnicode'
    },
    postalCode: {
      maxlength: 35,
      validator: 'Validator.AAA.PostalCode'
    }
  };

  const SUPPORT_SERVICE = 'supportapp_service';
  const PORTAL_SERVICE = 'portal_service';
  const CAPTCHA_PATH = 'captcha/key';
  const US_COUNTRY_CODE = 'US';
  const CANADA_COUNTRY_CODE = 'CA';
  const ANONYMOUS_CASES_URL = '/api/supportapp-service/v1/cases/anonymous';
  const S3_BUCKET = 's3.amazonaws.com';

  // See https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-query-string-query.html#_reserved_characters
  const RESERVED_CHARS = ['\\+', '-', '=', '&', '\\||', '<', '>', '!', '\\(', '\\)', '{', '}', '\\[', '\\]', '\\^',
                        '"', '~', '\\*', '\\?', ':', '\\\\', '/'];

  let locale = {};
  let myParams = {};
  let captchaId;
  let directNavigation = false;
  let anonymousTutorials = {};
  let slicedAnonymousTutorials = {};

  let vm = this;
  vm.errorKey = null;
  vm.loading = true;
  vm.submitting = false;
  vm.signInHelp = false;
  vm.countryHelp = false;
  vm.recaptchaResponse = '';
  vm.helpCenterEnabled = false;
  vm.articles = [];
  vm.expanded = false;

  // controller functions
  vm.getCountry = getCountry;
  vm.getCountries = getCountries;
  vm.countryChanged = countryChanged;
  vm.submit = submit;
  vm.cancel = cancel;
  vm.signInHelpClicked = signInHelpClicked;
  vm.countryHelpClicked = countryHelpClicked;
  vm.prepareFormInfoToSend = prepareFormInfoToSend;
  vm.renderRecaptcha = renderRecaptcha;
  vm.executeRecaptcha = executeRecaptcha;
  vm.signin = signin;
  vm.$onInit = onInit;
  vm.searchInsideTutorials = searchInsideTutorials;
  vm.seeAllArticles = seeAllArticles;
  vm.seeSlicedArticles = seeSlicedArticles;
  vm.hasArticles = hasArticles;
  vm.clickOnArticle = clickOnArticle;

  vm.unitTest = {
    sanitizeText,
    getHelpCenterEnabledRegistryKey,
    getAnonymousTutorials,
    sortArticles,
    sortByTitle,
    setAnonymousTutorials: value => anonymousTutorials = value,
    setSlicedAnonymousTutorials: value => slicedAnonymousTutorials = value,
  };

  ////////////////////////
  function onInit() {
    detectUnsupportedBrowsers();
    getHelpCenterEnabledRegistryKey();

    let promises = [];
    promises.push();
    promises.push(getCountries());
    promises.push(getSiteKey());
    promises.push(getLocale().then(() => getAnonymousTutorials()));

    return $q.all(promises)
      .then((data) => {
        vm.countries = data[0];
        parseParams();
      })
      .finally(() => {
        countryChanged();
        if (!$window.grecaptcha) {
          // Just display the email support button instead of reusing the signup error message (which is signup specific).
          //vm.errorKey = 'register.register.SignUp_Error_NoCaptcha';
          vm.noCaptcha = true;
        }
        vm.loading = false;
      });
  }

  function detectUnsupportedBrowsers() {
    vm.isUnsupportedBrowser =  ($window.navigator.userAgent.indexOf("MSIE") !== -1) || ($window.navigator.userAgent.indexOf("rv:11") !== -1);
  }

  function parseParams() {
    let urlParams = $location.search();

    myParams.data = $stateParams.data;
    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }

    if (urlParams.target) {
      myParams.data = {};
      _.set(myParams, 'data.target.url', $window.decodeURIComponent(urlParams.target));
      directNavigation = true;
    }
  }

  function getLocale() {
    return rnLocale.getBestFit().then(l => {
      locale = l;
    });
  }

  /**
   * @summary Get the google captcha site key from support app service.
   * @return sets the vm.request.captchaId
   */
  function getSiteKey() {
    return rnHttp.get(SUPPORT_SERVICE, CAPTCHA_PATH, {version: 1}).then(resp => {
      _.set(vm, 'request.captchaId', resp.data.key);
    });
  }

  function getCountry(isoCode) {
    return _.find(vm.countries, {isoCode: isoCode});
  }

  function getCountries() {
    let portalCountriesOpts = {
      cache: true,
      params: {
        locale: locale.value
      }
    };

    return rnHttp.get(PORTAL_SERVICE, 'preferences/countries', portalCountriesOpts)
      .then(response => response.data);
  }

  function countryChanged() {
    let country = getCountry(vm.country);
    if (country) {
      switch (country.isoCode) {
        case US_COUNTRY_CODE:
          vm.validators = US_VALIDATORS;
          break;
        case CANADA_COUNTRY_CODE:
          vm.validators = CANADA_VALIDATORS;
          break;
        default:
          vm.validators = DEFAULT_VALIDATORS;
          break;
      }
    }
  }

  function renderRecaptcha() {
    if ($window.grecaptcha) {
      captchaId = $window.grecaptcha.render('recaptchaSupport', {
        sitekey: vm.request.captchaId,
        callback: submit,
        // Recaptcha errors are also handled in submit method
        'error-callback': submit,
        'expired-callback': submit,
      });
    }
  }

  function executeRecaptcha() {
    if ($window.grecaptcha) {
      $window.grecaptcha.execute(captchaId);
    }
  }

  /**
   * @summary Post the support form information (as jsonBlob) to support app service
   * @return response about support email sent successfully or not
   */
  function submit() {
    vm.submitting = true;
    delete vm.errorKey;

    if ($window.grecaptcha) {
      _.set(vm, 'request.captchaBytes', $window.grecaptcha.getResponse(captchaId));
    }

    if (!vm.request.captchaBytes || (vm.request.captchaBytes && vm.request.captchaBytes === '')) {
      vm.errorKey = 'register.register.SignUp_Error_Captcha';
      vm.submitting = false;
      return;
    }

    //Prepare support form input
    let data = {
      case: Upload.jsonBlob(prepareFormInfoToSend())
    };

    Upload.upload({
      url: ANONYMOUS_CASES_URL,
      data: data
    }).then(response => {
        vm.success = true;
        $analytics.eventTrack('support request sent', { category: 'account'});
      })
      .catch(function (error) {
        if ($window.grecaptcha) {
          $window.grecaptcha.reset(captchaId);
        }
        vm.errorKey = 'uxf.uxf.ContactHPSupport_error';
      })
      .finally(() => {
        vm.submitting = false;
      });
  }

  /**
   * @summary Prepare support form input in JSON format.
   * @return json
   */
  function prepareFormInfoToSend(){
    const sendParams = {
      caseSource: "WEB",
      subject: vm.request.subject,
      type: "ANONYMOUS_QUESTION",
      userEntries: [
        {
          userEntryType: "EMAIL",
          value: vm.request.email
        },
        {
          userEntryType: "FIRST_NAME",
          value: vm.request.firstName
        },
        {
          userEntryType: "LAST_NAME",
          value: vm.request.lastName
        },
        {
          userEntryType: "COUNTRY",
          value: vm.request.country
        },
        {
          userEntryType: "ACCOUNT_NAME",
          value: vm.request.accountName
        },
        {
          userEntryType: "DESCRIPTION",
          value: vm.request.message
        },
        {
          userEntryType: "RECAPTCHA_RESPONSE",
          value: vm.request.captchaBytes
        }
      ]
    };
    return sendParams;
  }

  function cancel() {
    if (directNavigation) {
      let target = _.get(myParams, 'data.target.url');
      $window.location.href = target;
    } else {
      $state.go($stateParams.fromState, myParams);
    }
  }

  function signInHelpClicked(){
    vm.signInHelp = !vm.signInHelp;
    if (vm.signInHelp) {
      $gzAnalytics.eventClick('Support - Help opened');
    }
    else {
      $gzAnalytics.eventClick('Support - Help closed');
    }
  }

  function countryHelpClicked(){
    vm.countryHelp = !vm.countryHelp;
  }

  function signin(type = 'login') {
    vm.submitting = true;
    delete vm.errorKey;

    $gzAnalytics.eventClick('Sign In From Support - Sign in clicked');

    let returnUrl = $gzHpId.createTargetUrl('signin', {
      messageKey: vm.messageKey,
      messageParams: vm.messageParams,
      target: _.get(myParams, 'data.target.url'),
    });

    let params = {
      locale: locale,
      username: $stateParams.username,
      userId: $stateParams.userId,
      orgId: $stateParams.orgId,
      forceLogin: true
    };

    return $gzHpId.redirect(type, returnUrl, params).catch(() => {
      vm.submitting = false;
      vm.errorKey = 'register.register.SignIn_Error_HPID_RedirectFailed';
    });
  }

  function getAnonymousTutorials() {
    let urlParams = $location.search();
    vm.expanded = (urlParams.expanded === "true");

    const config = {
      params: {
        visibleForAnonymous: true,
        locale: locale.value
      }
    };

    return rnHttp.get(SUPPORT_SERVICE, 'tutorials', config).then(resp => {
      // We should not have anonymous walkme tutorials
      anonymousTutorials = sortArticles(resp.data && resp.data.list && resp.data.list.filter(tutorial => !tutorial.type.includes('walk')), sortByTitle);
      anonymousTutorials = mountLink(anonymousTutorials);
      slicedAnonymousTutorials = anonymousTutorials.slice(0, 5);
      vm.articles = vm.expanded ? anonymousTutorials : slicedAnonymousTutorials;
    });
  }

  function mountLink(articles) {
    return articles.map(article => {
      switch (article.type) {
        case 'video':          
        case 'url': {
          if (article.content.includes(S3_BUCKET)) {
            article.link = "#/help/" + article.id;
          } else {
            article.link = article.content;
          }
          break;
        }
        case 'pdf': {
          article.link = "#/help/" + article.id;
          break;
        }            
        default: {
          article.link = article.content;
          break;
        }
      }
      return article;
    });
  }

  function searchInsideTutorials(text) {
    if (text.length === 0) {
      vm.articles = vm.expanded ? anonymousTutorials : slicedAnonymousTutorials;
      return;
    }

    const config = {
      params: {
        hasText: sanitizeText(text),
        locale: locale.value
      }
    };

    return rnHttp.get(SUPPORT_SERVICE, 'searchdocs/tutorials', config).then(resp => {
      if (vm.inputText === text) {
        let analyticsTitles = resp.data.list.map(tutorial => tutorial.analyticsTitle);
        vm.articles = anonymousTutorials.filter(tutorial => analyticsTitles.includes(tutorial.analyticsTitle));
      }
    });
  }

  function removeSpecialChars(text) {
    let sanitizedText = text;
    RESERVED_CHARS.forEach((reservedChar) => {
      sanitizedText = sanitizedText.replace(new RegExp(reservedChar, 'g'), '');
    });

    return sanitizedText;
  }

  // based on printos-blue-ui/test/unit/specs/services/search-docs.js
  function sanitizeText(uncheckedText) {
    let text = uncheckedText ? uncheckedText.trim() : '';
    return (text.length === 0) ? text : removeSpecialChars(text).trim();
  }

  function getHelpCenterEnabledRegistryKey() {
    rnRegistry.getRegistry().then(registry => {
      vm.helpCenterEnabled = registry.keys.helpCenterEnabled;
    });
  }

  function seeAllArticles() {
    $gzAnalytics.eventClick('Support - See all articles');
    vm.articles = anonymousTutorials;
    vm.inputText = '';
    vm.expanded = true;
    $location.search('expanded', 'true');
  }

  function seeSlicedArticles() {
    vm.articles = slicedAnonymousTutorials;
    vm.inputText = '';
    vm.expanded = false;
    $location.search('expanded', 'false');
  }

  function clickOnArticle(analyticsTitle) {
    $gzAnalytics.eventClick('Support - Click on article', {label: `${analyticsTitle}`});
  }

  function hasArticles() {
    return vm.articles.length > 0;
  }

  function sortArticles(anonymousTutorials, sortByTitle){
    return anonymousTutorials.filter(article => article.faq === true).sort((a,b) => sortByTitle(a,b))
      .concat(anonymousTutorials.filter(article => article.faq === false).sort((a,b) => sortByTitle(a,b)));
  }

  function sortByTitle(a,b) {
    return a.title.trim().toLocaleLowerCase().localeCompare(b.title.trim().toLocaleLowerCase());
  }
}



// WEBPACK FOOTER //
// ./components/support/support.controller.js